/**
 * Featured Products shelf: arrow controls, keyboard scroll, end-of-track fade.
 * Arrows only appear when the track actually overflows (e.g. more than ~4 on desktop).
 */
(function () {
  function slideDelta(track) {
    var slide = track.querySelector('.productgrid--item');
    if (!slide) return track.clientWidth * 0.8;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateShelf(track, section) {
    if (!section || !track) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var canScroll = maxScroll > 2;
    section.classList.toggle('has-overflow', canScroll);

    if (!canScroll) {
      section.classList.add('is-at-end');
      section.classList.add('is-at-start');
    } else {
      section.classList.toggle('is-at-start', track.scrollLeft <= 2);
      section.classList.toggle('is-at-end', track.scrollLeft >= maxScroll - 2);
    }

    var prev = section.querySelector('[data-featured-prev]');
    var next = section.querySelector('[data-featured-next]');
    if (prev) {
      prev.disabled = !canScroll || track.scrollLeft <= 2;
      prev.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
    }
    if (next) {
      next.disabled = !canScroll || track.scrollLeft >= maxScroll - 2;
      next.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
    }
  }

  function scrollByDir(track, dir) {
    track.scrollBy({ left: slideDelta(track) * dir, behavior: 'smooth' });
  }

  function onKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var track = event.currentTarget;
    event.preventDefault();
    scrollByDir(track, event.key === 'ArrowLeft' ? -1 : 1);
  }

  function initShelf(section) {
    var track = section.querySelector('.collection-featured-products__track');
    if (!track) return;

    var prev = section.querySelector('[data-featured-prev]');
    var next = section.querySelector('[data-featured-next]');

    function refresh() {
      updateShelf(track, section);
    }

    refresh();
    track.addEventListener('scroll', refresh, { passive: true });
    track.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', refresh);

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByDir(track, -1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByDir(track, 1);
      });
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(refresh);
      ro.observe(track);
    }
  }

  function init() {
    document.querySelectorAll('.collection-featured-products').forEach(initShelf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
